import { API } from "../api/API";
import VTAPI from "../api/VTAPI";
import { validateResponseStatus } from "../utils";

export const getToken = async (token) => {
  const result = await API()
    .get("academy/user/getTokenVT")
    .catch((error) => {
      return error.response ? error.response : { error };
    });

  return result;
};

export const getInfoByEmail = async (email) => {
  const result = await API()
    .get(`/user/user/getByEmail/${email}`)
    .catch((error) => {
      return error.response ? error.response : { error };
    });

  return result;
};

export const getByContactId = async (language, contactId, token) => {
  const result = await VTAPI(token)
    .get(`/Contact/${language}/${contactId}`)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  return result;
};

export const createContact = async (payload) => {
  const result = await API()
    .post(`/user/user/create`, payload)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  return result;
};

export const getListIdentificationType = async (language, token) => {
  const result = await VTAPI(token)
    .get(`/IdentificationType/${language}`)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  return result;
};

export const getContactRelationIbo = async (payload, token) => {
  const result = await API()
    .post(`academy/user/ContactRelation`, payload)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  return result;
};
